import React from 'react';
import Main from './Main';

const App = props => {
    return (
        <div >
            <Main />
        </div>
    );
}

export default App;